import styles from './title.module.css'

export default function Title({ title, subTitle }) {
  return (
    <h1>
      {title} <span>{subTitle}</span>
    </h1>
  )
}
